import { startsWith } from 'lodash-es';
import { join } from '@/utils/url';
export default {
  name: 'ImageCdn',
  props: {
    // 图片路径
    src: {
      type: String,
      default: '',
      required: true
    },
    // 使用 cdn 暂未实作
    cdn: {
      type: Boolean,
      default: true
    },
    // html tag attributes
    // ex. width, height...
    attrs: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    // 是否加载 cdn
    availableCdn(src) {
      return this.cdn && src &&
      // 开头有 http 或双斜线都不加 cdn
      !startsWith(src, 'http') && !startsWith(src, '//') && (
      // 正式环境或非本地资源一律加上 cdn
      process.env.NODE_ENV === 'production' || src.indexOf('assets/img') === -1);
    }
  },
  computed: {
    /** 最终路径 */
    newSrc() {
      let src = this.src;

      // base64 图片不做任何处理
      if (startsWith(src, 'data:')) {
        return src;
      }
      if (process.env.NODE_ENV === 'development') {
        return '/n/' + src;
      }
      // 图片走 cdn
      if (this.availableCdn(src)) {
        if (src.startsWith('img/') && !this.$cdn.startsWith('http://10.82.5')) src = 'n/' + src;
        src = join(this.$cdn, src);
      }
      return src;
    },
    elementTag() {
      return {
        src: this.newSrc
      };
    }
  }
};